export default "__VITE_ASSET__DgqE$PMd__"